// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonFilters = {
  all: "All",
  createdBy: "Created By",
  updatedBy: "Updated By",
} as const;
